import {Loader} from '@googlemaps/js-api-loader';
import mapStyles from './app/mapStyles';
import BranchesMap from './app/branchesMap';

window.icons = {
    agency: '/static/images/maps/agency.svg',
    atm:    '/static/images/maps/atm.svg',
    here:   '/static/images/maps/here.svg',
    hq:     '/static/images/maps/hq.svg'
};

const slug = (branch) => window.slugger([
                                            branch.county,
                                            branch.name
                                        ].join('-'));

window.geocodePosition = (pos, callback) => {
    const geocoder = new google.maps.Geocoder();
    let address    = '';
    geocoder.geocode({latLng: pos}, function(responses) {
        if (responses && responses.length > 0) {
            address = responses[0].formatted_address;
        } else {
            address = false;
        }

        callback(address);
    });
};
window.branchesList    = window.branchesList ?? [];

window.initMap = () => {

    const branches = new BranchesMap(
        {
            map:                 new google.maps.Map(_q('#map'), {
                mapTypeControlOptions:    {
                    mapTypeIds: []
                },
                zoomControlOptions:       {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                },
                streetViewControl:        false,
                center:                   window.branchesList.filter(b => b.type.indexOf('hq') >= 0)[0],
                zoom:                     14,
                styles:                   mapStyles
            }),
            branches:            window.branchesList,
            currentBranch:       window.currentBranch ?? null,
            autocompleteElement: _q('#map-filters input[name=query]')
        });

    window.branches = branches;
    _q('[name=localize]').addEventListener('click', window.branches.locate.bind(window.branches));

};

const loader = new Loader(
    {
        apiKey:    'AIzaSyBmD-1eruqh8zUKyIPxodGQbBgLfkxA-RE',
        version:   'weekly',
        language:  window.locale,
        region:    'RO',
        libraries: ['places']
    });

loader.load().then(() => {
    initMap();
});
